import { PriceRuleConditionBase } from "./price-rule-condition.base";

export class PriceRuleVehicleView extends PriceRuleConditionBase {
    public vehicleGroupCode: string;
    public vehicleTypeCode: string;
    public vehicleCompositionId: string;
}